<script lang="ts" setup>
    import { onMounted } from 'vue';
    import { useUserStore } from '@/stores/user';
    import i18n from '@/plugins/i18n';
    import { EventName, Platform } from '@/constants';
    import eventBus from '@/services/eventBus';
    import { userService } from '@/services/userService';
    import { getPlatform } from '@/helpers/getPlatform';
    import { languageDictionary, timeZoneDictionary } from '@/stores';

    const { t, locale } = useI18n();

    const userStore = useUserStore();

    const setLocale = (lang: string): void => {
        if (!lang) return;

        locale.value = lang;
        localStorage.setItem('locale', lang);
        eventBus.emit(EventName.LanguageChanged, lang);
    };

    const setTimeZone = async (value: string): Promise<void> => {
        if (!value) return;

        if (userStore.isLoggedIn()) {
            await userService.changeTimeZone(value);
            userStore.timeZone = value;
        } else {
            userStore.timeZone = value;
            //todo uncomment and fix it
            //localStorage.setItem('user', JSON.stringify(user.value));
        }
    };

    onMounted((): void => {
        console.log('Component app-menuAccountChangeLocaleAndTimeZone mounted.');
    });
</script>
<template>
    <v-card-text class="py-0">
        <v-container class="px-4 py-3">
            <v-row>
                <v-col v-if="getPlatform() === Platform.Tradeball" class="pl-0 pr-1 py-3" cols="6">
                    <v-autocomplete
                        autocomplete="off"
                        density="compact"
                        variant="outlined"
                        :hide-details="true"
                        ref="localeValue"
                        class="filter"
                        color="grey"
                        :label="t('menu.language')"
                        :items="languageDictionary.items"
                        item-value="id"
                        item-title="name"
                        :model-value="i18n.global.locale.value"
                        @update:model-value="setLocale"
                    ></v-autocomplete>
                </v-col>
                <v-col :cols="getPlatform() === Platform.Tradeball ? 6 : 12" class="pl-1 pr-0 py-3">
                    <v-autocomplete
                        autocomplete="off"
                        density="compact"
                        variant="outlined"
                        :hide-details="true"
                        ref="timeZoneValue"
                        class="filter"
                        color="grey"
                        :label="t('menu.timeZone')"
                        :items="timeZoneDictionary.items"
                        item-value="id"
                        item-title="gmtOffset"
                        :model-value="userStore.timeZone"
                        @update:model-value="setTimeZone"
                        :menu-props="{
                            contentProps: {
                                style: 'min-width: 300px',
                            },
                        }"
                    >
                        <template v-slot:item="{ props: itemProps, item }">
                            <v-list-item v-bind="itemProps" :subtitle="item.raw.name"></v-list-item>
                        </template>
                    </v-autocomplete>
                </v-col>
            </v-row>
        </v-container>
    </v-card-text>
</template>
<style scoped>
    .my-select-menu {
        min-width: 320px !important;
    }
</style>
